<template>
  <div>
    <vue-qrcode :value="qrcodeurl()" :options="{ width: 200 }"></vue-qrcode>
  </div>
</template>

<script>
import VueQrcode from "vue-qrcode"

export default {
  props: ['qrstring', 'workspaceid', 'qrworkspaceid'],
  components: {
    VueQrcode
  },
  data() {
    return {
    }
  },
  methods: {
    qrcodeurl() {
      let urlstring = this.qrstring;
      if (this.qrstring === 'undefined' || this.qrstring === undefined)
        urlstring = `${this.workspaceid}/${this.qrworkspaceid}`;
      // eslint-disable-next-line
      return process.env.VUE_APP_CLIENTURL + '/m/' + urlstring

    }
  }
}
</script>
<style></style>
